import { getCurrentSubscription } from './subscriptionQueries';
import { SubscriptionTier } from './types';

export const canAccessCallScripts = async (): Promise<boolean> => {
  const subscription = await getCurrentSubscription();
  const tier = subscription?.tier || 'free';
  
  // Only Starter, Pro, and Unlimited can access call scripts
  return ['starter', 'pro', 'unlimited'].includes(tier);
};

export const canAccessAnalytics = async (): Promise<boolean> => {
  const subscription = await getCurrentSubscription();
  const tier = subscription?.tier || 'free';
  
  // Only Pro and Unlimited can access advanced analytics
  return ['pro', 'unlimited'].includes(tier);
};

export const getCurrentTier = async (): Promise<SubscriptionTier> => {
  const subscription = await getCurrentSubscription();
  return subscription?.tier || 'free';
};

export const getTierDisplayName = (tier: SubscriptionTier): string => {
  const tierNames = {
    free: 'Free',
    starter: 'Starter',
    pro: 'Pro',
    unlimited: 'Unlimited'
  };
  return tierNames[tier] || 'Free';
};
